import './App.css'

import { LogsProvider } from '@/providers/Logs'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import ErrorPage from './core/Error'
import { AdminLayout } from './layouts/AdminLayout'
import { MainLayout } from './layouts/Main'
import AboutPage from './pages/About/About'
import Home from './pages/Home/Home'
import AppSettingsPage from './pages/admin/app-settings/AppSettingsPage'
import BillViewPage from './pages/admin/bill/BillViewPage'
import ContractsPage from './pages/admin/contracts/ContractsPage'
import EdgeFunctionsPage from './pages/admin/edge-functions/EdgeFunctionsPage'
import ExportBillPage from './pages/admin/export-bill/ExportBillPage'
import NewPaymentSystemPlanPage from './pages/admin/features/NewPaymentSystemPlan'
import MonthlyRecordsPage from './pages/admin/monthly-records/MonthlyRecordsPage'
import PlannedFeaturesPage from './pages/admin/planned-features/PlannedFeaturesPage'
import ProfilesPage from './pages/admin/profiles/ProfilesPage'
import ReportPage from './pages/admin/report/ReportPage'
import RoomsPage from './pages/admin/rooms/RoomsPage'
import UtilityRecordsPage from './pages/admin/utility-records/UtilityRecordsPage'
import { UserCallbackPage } from './pages/auth/Callback'
import { LoginPage } from './pages/auth/LoginPage'
import { useAuthListener } from './stores/authStore'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <MainLayout>
        <Home />
      </MainLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/about',
    element: (
      <MainLayout>
        <AboutPage />
      </MainLayout>
    ),
    errorElement: <ErrorPage />,
  },

  // ── Auth ─────────────────────────────────────────────────
  {
    path: '/auth/login',
    element: (
      <MainLayout>
        <LoginPage />
      </MainLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/auth/callback',
    element: (
      <MainLayout>
        <UserCallbackPage />
      </MainLayout>
    ),
    errorElement: <ErrorPage />,
  },

  // ── Admin ────────────────────────────────────────────────
  {
    path: '/admin',
    element: <Navigate to="/admin/monthly-records" replace />,
  },
  {
    path: '/admin/rooms',
    element: (
      <AdminLayout>
        <RoomsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/utility-records',
    element: (
      <AdminLayout>
        <UtilityRecordsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/contracts',
    element: (
      <AdminLayout>
        <ContractsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/profiles',
    element: (
      <AdminLayout>
        <ProfilesPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/monthly-records',
    element: (
      <AdminLayout>
        <MonthlyRecordsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/export-bill',
    element: (
      <AdminLayout>
        <ExportBillPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/report',
    element: (
      <AdminLayout>
        <ReportPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/app-settings',
    element: (
      <AdminLayout>
        <AppSettingsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    // http://localhost:3000/admin/bill/203?month=2026-03
    path: '/admin/bill/:roomNumber',
    element: <BillViewPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/edge-functions',
    element: (
      <AdminLayout>
        <EdgeFunctionsPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/features/new-payment-system-plan',
    element: (
      <AdminLayout>
        <NewPaymentSystemPlanPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/planned-features',
    element: (
      <AdminLayout>
        <PlannedFeaturesPage />
      </AdminLayout>
    ),
    errorElement: <ErrorPage />,
  },
])

function App() {
  useAuthListener()

  return (
    <LogsProvider>
      <RouterProvider router={router} />
    </LogsProvider>
  )
}

export default App
